import { RedirectToLegacyEcommerceProductOfferOptions } from './types';

export const redirectToLegacyEcommerceProductOffersPage = ({
  discountCode,
}: RedirectToLegacyEcommerceProductOfferOptions) => {
  const params = new URLSearchParams();

  if (discountCode) {
    params.set('code', discountCode);
  }
  window.location.replace(
    `${`${process.env.NEXT_PUBLIC_EDX_LEGACY_ECOM_BASE_URL!}/coupons/offer/`}?${params.toString()}`,
  );
};
